// extracted by mini-css-extract-plugin
export default {"section":"Section_section__Z2PLw","title":"Section_title__SLHvV"};